import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ChatBot from './components/ChatBot';
import ScrollToTop from './components/ScrollToTop';
import SeoHead from './components/SeoHead';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import PhysicalDistribution from './pages/PhysicalDistribution';
import CopyrightReport from './pages/CopyrightReport';
import MusicPublishing from './pages/MusicPublishing';
import ArtistServices from './pages/ArtistServices';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SeoHead />
      <div className="min-h-screen" style={{ backgroundColor: 'rgb(249, 250, 251)' }}>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/physical-distribution" element={<PhysicalDistribution />} />
            <Route path="/copyright-report" element={<CopyrightReport />} />
            <Route path="/music-publishing" element={<MusicPublishing />} />
            <Route path="/artist-services" element={<ArtistServices />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <ChatBot />
      </div>
    </Router>
  );
}

export default App;
